const REFERENCE_LENGTH = 8;

/**
 * A short customer-facing reference for an invoice that has no processor
 * number (a direct charge creates no Stripe Invoice). It is a prefix of the
 * id, so the full id on the document resolves any doubt.
 */
export function formatInvoiceReference(invoiceId: string): string {
  return invoiceId.slice(0, REFERENCE_LENGTH).toUpperCase();
}
